import React from 'react';
import { format } from 'date-fns';
import { MainSection } from '@/components/layout/MainSection';
import { SectionContent } from '@/components/layout/SectionContent';
import { MatchDetailCard } from '@/components/MatchDetailCard';
import { useMatchOverviewContext } from '@/layouts/MatchOverviewLayout/context';
import { getDateLocale } from '@/utils/dateLocale';

/**
 * `/match/:matchId` — the match itself: hero card (teams, score or kickoff,
 * live minute, status). No tournament context, so no prediction /
 * coefficient strips; the tournaments containing the match live in their own tab.
 */
const OverviewTab: React.FC = () => {
  const { match, league } = useMatchOverviewContext();

  const kickoffLabel = format(new Date(match.match_date), 'd MMMM yyyy, HH:mm', { locale: getDateLocale() });

  // On desktop the sidebar's TournamentInfoCard already shows the league
  // chrome — hide the title/logo there (the kickoff subtitle stays).
  return (
    <MainSection
      hideTitleOnDesktop
      title={league.name}
      subtitle={kickoffLabel}
      logoUrl={league.logoUrl || undefined}
      logoAlt={league.name}
    >
      <SectionContent>
        <div data-testid="match-overview" data-match-id={match.id} data-status={match.status}>
          <MatchDetailCard
            match={{
              id: match.id,
              team1: match.team1,
              team2: match.team2,
              team1_logo_url: match.team1_logo_url ?? undefined,
              team2_logo_url: match.team2_logo_url ?? undefined,
              match_date: match.match_date,
              status: match.status,
              score_team1: match.score_team1,
              score_team2: match.score_team2,
              venue: match.venue ?? undefined,
              elapsed_minutes: match.elapsed_minutes,
              elapsed_extra_minutes: match.elapsed_extra_minutes,
              elapsed_updated_at: match.elapsed_updated_at,
            }}
          />
        </div>
      </SectionContent>
    </MainSection>
  );
};

export default OverviewTab;
